<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <v-container>
      <base-material-card
        icon="mdi-clipboard-text"
        title="Agenda de contactos:"
      >
        <v-container>
          <v-data-table
            :headers="headers"
            :items="contacts"
            item-key="name"
            class="elevation-1"
            :search="search"
            :loading="isLoadingData"
          >
            <template v-slot:top>
              <v-row
                class="pa-4"
              >
                <v-col
                  class="py-0 my-0"
                >
                </v-col>
                <v-col
                  class="py-0 my-0"
                >
                  <v-text-field
                    v-model="search"
                    label="Buscar en usuarios..."
                    outlined
                  />
                </v-col>
              </v-row>

              <v-btn
                v-if="$store.getters.hasPermission('Contactos', 'Descargar')"
                color="primary"
                :loading="isLoadingDownload"
                @click="dowloadExcel"
              >
                Descargar data
                <v-icon> mdi-download </v-icon>
              </v-btn>
            </template>
            <template v-slot:[`item.accions`]="{ item }">
              <v-tooltip
                top
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                    @click="openModificarContacto(item)"
                  >
                    mdi-pencil
                  </v-icon>
                </template>
                <span>Modificar</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon 
                    small
                    v-bind="attrs"
                    v-on="on"
                    @click="confirmDeleteContact(item)"
                  >
                    mdi-trash-can-outline
                  </v-icon>
                </template>
                <span>Eliminar</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-container>
        <v-speed-dial
          v-model="fab"
          fixed
          bottom
          right
          absolute
          :open-on-hover="hover"
          :transition="transition"
        >
          <template v-slot:activator>
            <v-btn
              v-if="$store.getters.hasPermission('Contactos', 'Crear')"
              v-model="fab"
              color="blue darken-2"
              dark
              fab
            >
              <v-icon v-if="fab">
                mdi-close
              </v-icon>
              <v-icon v-else>
                mdi-plus
              </v-icon>
            </v-btn>
          </template>
          <v-btn
            fab
            dark
            small
            color="red"
            @click="dialogNuevoContacto = true"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
          <v-btn
            fab
            dark
            small
            color="green"
            @click="openDiaogUpload"
          >
            <v-icon>mdi-paperclip</v-icon>
          </v-btn>
        </v-speed-dial>
        <v-dialog
          v-model="dialogNuevoContacto"
          persistent
          max-width="600px"
        >
          <v-card>
            <v-card-title>
              <span class="text-h5">
                {{ isEditMode ? 'Editar contacto' : 'Nuevo contacto' }}
              </span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <template>
                  <v-form
                    ref="form"
                    v-model="validNuevoContacto"
                    lazy-validation
                    @submit.prevent="submitContact()"
                  >
                    <v-combobox
                      v-if="!isEditMode"
                      v-model="nuevoContacto.empresa"
                      :items="empresasCombobox"
                      label="Empresa"
                      :rules="[v => !!v || 'Empresa es obligatorio']"
                      required
                      outlined
                      @keydown="keyDownComboEmpresa"
                    />
                    <v-text-field
                      v-model="nuevoContacto.contactName"
                      label="Nombre de contacto"
                      :rules="[v => !!v || 'Nombre de contacto es obligatorio']"
                      required
                      outlined
                    />
                    <v-text-field
                      v-model="nuevoContacto.addressContact"
                      label="Dirección*"
                      :rules="[v => !!v || 'Dirección es obligatorio']"
                      required
                      outlined
                    />
                    <v-text-field
                      v-model="nuevoContacto.contactTelephone"
                      label="Telefono corporativo"
                      type="number"
                      :rules="[
                        v => !!v || 'Telefono corporativo es obligatorio',
                        v => v.length > 6 || 'Telefono corporativo debe tener 6 digitos por lo menos',
                      ]"
                      required
                      outlined
                    />
                    <v-text-field
                      v-model="nuevoContacto.contactTelephone2"
                      label="Teléfono personal"
                      type="number"
                      outlined
                    />
                    <v-text-field
                      v-model="nuevoContacto.emailContact"
                      label="Email corporativo"
                      :rules="[
                        v => !!v || 'Email corporativo es obligatorio',
                        v => /.+@.+\..+/.test(v) || 'Email corporativo no es válido',
                      ]"
                      required
                      outlined
                    />
                    <v-text-field
                      v-model="nuevoContacto.emailContact2"
                      label="Email personal"
                      outlined
                    />
                    <v-text-field
                      v-model="nuevoContacto.positionContact"
                      label="Cargo"
                      :rules="[v => !!v || 'Cargo es obligatorio']"
                      required
                      outlined
                    />
                    <v-col>
                      <v-row
                        justify="end"
                      >
                        <v-btn
                          @click="dialogNuevoContacto = false"
                        >
                          Cerrar
                        </v-btn>
                        <v-btn
                          color="primary"
                          class="mx-0"
                          type="submit"
                          :loading="isLoadingNuevoContacto"
                        >
                          {{ isEditMode ? 'Guardar cambios' : 'Crear contacto' }}
                        </v-btn>
                      </v-row>
                    </v-col>
                  </v-form>
                </template>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="dialogConfirmDelete"
          max-width="400"
        >
          <v-card>
            <v-card-title class="headline">
              Confirmar eliminación
            </v-card-title>
            <v-card-text>
              ¿Estás seguro que deseas eliminar este contacto?
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="dialogConfirmDelete = false"
              >
                Cancelar
              </v-btn>
              <v-btn
                text
                color="green"
                @click="handleConfirmDelete"
              >
                Eliminar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </base-material-card>
    </v-container>
 
    <upload-contact-by-excel
      ref="uploadContacts"
      @onUploadExcel="onUploadExcel"
    />
  </v-container>
</template>

<script>
import xlsx from 'json-as-xlsx'
import UploadContactByExcel from './components/AgregarPorExcel.vue'
import firebase from 'firebase'
export default {
  components: {
    UploadContactByExcel
  },
  data: () => ({
    isEditMode:false,
    dialogAgregarContacto: false,
    validNuevoContacto: true,
    nuevoContacto: {
      associated: '',
      addressContact: '',
      contactName: '',
      contactTelephone: '',
      contactTelephone2: '',
      emailContact: '',
      emailContact2: '',
      positionContact: '',
    },
    selectedContact: null,
    isLoadingNuevoContacto: false,
    isLoadingUpdate: false,
    direction: 'top',
    fab: false,
    hover: false,
    transition: 'slide-y-reverse-transition',
    contactsAux: [],
    contacts: [],
    search: '',
    searchAssociated: '',
    tmp: [],
    empresas: [],
    empresasCombobox: [],
    empresa: ['Todos'],
    selectTipo: null,
    selectAssociated: null,
    isLoadingData: false,
    isLoadingSubmit: false,
    searchText: '',
    json_fields: {
      Modulo: 'modulo',
      Nombre: 'contactName',
      Empresa: 'associated',
      'Telefono Personal': 'contactTelephone',
      'Telefono Corporativo': 'contactTelephone2',
      'Email Personal': 'emailContact',
      'Email Corporativo': 'emailContact2',
      Cargo: 'positionContact',
      Dirección: 'addressContact',
    },
    isLoadingContacto: false,
    dialogNuevoContacto: false,
    dialogModificarContacto: false,
    dialogConfirmDelete: false,
    contactToDelete:null,
    newContact: [],
    OptionEmpresas: [],
    isLoadingDownload: false
  }),
  computed: {
    headers() {
      return [
        {
          text: 'Modulo',
          value: 'modulo',
        },
        {
          text: 'Nombres',
          align: 'start',
          value: 'contactName',
        },
        {
          text: 'Empresa',
          value: 'associated',
        },
        {
          text: 'Dirección',
          value: 'addressContact',
        },
        {
          text: 'Email Personal',
          value: 'emailContact',
        },
        {
          text: 'Email Corporativo',
          value: 'emailContact2',
        },
        {
          text: 'Cargo',
          value: 'positionContact',
        },
        {
          text: 'Teléfono Personal',
          value: 'contactTelephone',
        },
        {
          text: 'Teléfono Corporativo',
          value: 'contactTelephone2',
        },
        {
          text: 'Acciones',
          value: 'accions'
        },
      ]
    },
    computedEmpresas() {
      var resultados = ['Todos']
      this.empresas.forEach(empresa => {
        resultados.push(empresa)
      })
      return resultados
    },
  },
  mounted() {
    this.getContacts()
    this.getEmpresas()
  },
  methods: {
    filterTable() {
      var filtro1
      this.contactsAux = this.contacts
      if (this.selectAssociated === 'Todos' || this.selectAssociated === null) {
        this.getContacts()
      } else {
        filtro1 = this.contacts.filter(contact => {
          return contact.associated === this.selectAssociated
        })
        this.contacts = filtro1
      }
    },
    async getContacts() {
  this.contacts = []
  this.isLoadingData = true

  try {
    const querySnapshot = await firebase.firestore().collection('contacts').get()

    querySnapshot.forEach((doc) => {
      const contactData = doc.data()

      const addValidContact = (contact) => {

        if (contact && (contact.contactName && contact.emailContact && contact.contactTelephone)) {
          this.contacts.push({
            uid: contact.uid || null,
            modulo: 'Proyectos',
            contactName: contact.contactName || '',
            associated: contact.associated || '',
            contactTelephone: contact.contactTelephone || '',
            contactTelephone2: contact.contactTelephone2 || '',
            addressContact: contact.addressContact || '',
            emailContact: contact.emailContact || '',
            emailContact2: contact.emailContact2 || '',
            positionContact: contact.positionContact || '',
          })
        }
      }

      if (Array.isArray(contactData.contactos)) {
        contactData.contactos.forEach(addValidContact)
      } else {
        Object.keys(contactData)
          .filter(key => /^\d+$/.test(key))
          .forEach(key => addValidContact(contactData[key]))
      }
    })
      } catch (error) {
        console.error('Error al obtener contactos:', error)
      } finally {
        this.isLoadingData = false
      }
    },
    getEmpresas() {
      this.empresas = [];
      firebase.firestore().collection('contacts').get().then(proyectos => {
        proyectos.forEach(proyecto => {
          this.empresas.push(proyecto.id);
        });
        this.empresasCombobox = this.empresas;
      });
    },
    keyDownComboEmpresa() {
      function onlyUnique(value, index, self) {
        return self.indexOf(value) === index
      }
      var unique = this.empresas.filter(onlyUnique)
      var term = this.nuevoContacto.empresa
      var search = new RegExp(term, 'i')
      const b = unique.filter(item => search.test(item))
      this.empresasCombobox = b.slice(1, 100)
    },
    async addContact() {
      if (!this.$refs.form.validate()) return

      this.isLoadingNuevoContacto = true
      const empresa = this.nuevoContacto.empresa
      const contacto = {
        uid: Date.now().toString(),
        addressContact: this.nuevoContacto.addressContact,
        associated: empresa,
        contactName: this.nuevoContacto.contactName,
        contactTelephone: this.nuevoContacto.contactTelephone,
        contactTelephone2: this.nuevoContacto.contactTelephone2,
        emailContact: this.nuevoContacto.emailContact,
        emailContact2: this.nuevoContacto.emailContact2,
        positionContact: this.nuevoContacto.positionContact,
        createdAt: this.formatoFecha ? this.formatoFecha() : new Date().toISOString(),
      }

      const contactRef = firebase.firestore().collection('contacts').doc(empresa)

      try {
        const doc = await contactRef.get()

        if (doc.exists) {
          await contactRef.update({
            contactos: firebase.firestore.FieldValue.arrayUnion(contacto)
          })
        } else {
          await contactRef.set({
            type: 3,
            contactos: [contacto]
          })
        }

        this.isLoadingNuevoContacto = false
        this.dialogNuevoContacto = false
        this.$refs.form.reset()
        this.getContacts()

      } catch (error) {
        console.error('Error al agregar contacto:', error)
        this.isLoadingNuevoContacto = false
      }
    },
    openModificarContacto(contacto) {
      this.isEditMode = true;
      this.nuevoContacto = { ...contacto };
      this.selectedContact = { ...contacto };
      this.dialogNuevoContacto = true;
    },
    async updateContact() {
      if (!this.selectedContact || !this.selectedContact.uid) return;

      this.isLoadingUpdate = true;
      const empresa = this.selectedContact.associated;
      const contactRef = firebase.firestore().collection('contacts').doc(empresa);

      try {
        const doc = await contactRef.get();
        if (doc.exists && doc.data().contactos) {
          const actualContacts = doc.data().contactos;
          const newContacts = actualContacts.map(c => {
            if (c.uid === this.selectedContact.uid) {
              return this.selectedContact;
            }
            return c;
          });
          await contactRef.update({ contactos: newContacts });
        }
        this.dialogNuevoContacto = false;
        this.isLoadingNuevoContacto = false;
        this.selectedContact = null;
        this.getContacts();
      } catch (error) {
        console.error('Error actualizando contacto:', error);
      } finally {
        this.isLoadingUpdate = false;
      }
    },
    submitContact() {
      if (!this.$refs.form.validate()) return;

      this.isLoadingNuevoContacto = true;

      if (this.isEditMode) {
        this.selectedContact = { ...this.nuevoContacto };
        this.updateContact();
      } else {
        this.addContact();
      }
    },
    handleConfirmDelete() {
      if (!this.contactToDelete) return;
      this.deleteContact(this.contactToDelete.uid, this.contactToDelete.associated);
      this.dialogConfirmDelete = false;
      this.contactToDelete = null;
    },
    async deleteContact(uid, associated) {
      if (!uid || !associated) return;

      this.isLoadingContacto = true;
      const contactRef = firebase.firestore().collection('contacts').doc(associated);
      try {
        const doc = await contactRef.get();
        if (doc.exists && doc.data().contactos) {
          const actualContacts = doc.data().contactos;
          const contactosFiltrados = actualContacts.filter(c => c.uid !== uid);
          await contactRef.update({ contactos: contactosFiltrados });
          this.getContacts();
        }
      } catch (error) {
        console.error('Error eliminando contacto:', error);
      } finally {
        this.isLoadingContacto = false;
      }
    },
    confirmDeleteContact(item) {
      this.contactToDelete = item;
      this.dialogConfirmDelete = true;
    },
    formatoFecha() {
      const fecha = new Date()
      const formato = 'dd/mm/yy'
      const map = {
        dd: fecha.getDate(),
        mm: fecha.getMonth() + 1,
        yy: fecha.getFullYear().toString().slice(-2),
        yyyy: fecha.getFullYear(),
      }
      const date = formato.replace(/dd|mm|yy|yyy/gi, matched => map[matched])
      return date + ' ' + fecha.getHours() + ':' + fecha.getMinutes() + ':' + fecha.getSeconds()
    },
    closeContactDialog() {
      this.dialogNuevoContacto = false;
      this.isEditMode = false;
      this.nuevoContacto = {
        associated: '',
        contactName: '',
        addressContact: '',
        contactTelephone: '',
        contactTelephone2: '',
        emailContact: '',
        emailContact2: '',
        positionContact: ''
      };
    },
    openDiaogUpload() {
      this.$refs.uploadContacts.open()
    },
    onUploadExcel() {
      this.getContacts()
    },
    async dowloadExcel() {
      try {
        this.isLoadingDownload = true
        const data = [
          {
            sheet: 'Campañas',
            columns: [
              { label: 'Modulo', value: 'modulo' },
              { label: 'Nombre', value: 'contactName' },
              { label: 'Empresa', value: 'associated' },
              { label: 'Telefono Personal', value: 'contactTelephone' },
              { label: 'Telefono Corporativo', value: 'contactTelephone2' },
              { label: 'Email Personal', value: 'emailContact' },
              { label: 'Email Corporativo', value: 'emailContact2' },
              { label: 'Cargo', value: 'positionContact' },
              { label: 'Dirección', value: 'addressContact' },
            ],
            content: [
              ...this.contacts
            ]
          }]

        const settings = {
          sheetName: 'Data',
          fileName: 'contactos'
        }

        await xlsx(data, settings)
        this.isLoadingDownload = false
      } catch (error) {
        this.isLoadingDownload = false
      }
    },
  },
}
</script>
